import React, { Component } from 'react';
import Aux from './../Wrapper/Auxiliary';

import CarouselItems from './CarouselItems';
import Logo from '../../assets/img/logo.png';
import { Link } from 'react-router-dom';
import { BottomLogo } from '../../Global/Constant'
import queryString from 'query-string'
import eventCallRequest from "../../Global/Helper/HelperEvent";
import { connect } from 'react-redux';
import * as actionCreators from "../../Redux/Actions";
import LoadingComponent from '../../common/UI/loadingComponent';

class paymentResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: '',
            ticket: '',
            endDate: '',
            endTime: '',
            phone: '',
            phonePre: '+1',
            email: '',
            pass_code: '',
            ticketech_code: '',
            isPass: false
        }
        this.dateDisplayFormat = 'MM/DD/YYYY';
        this.existingDateFormat = 'll';
        this.timeDisplayFormat = 'h:mm A';
        this.phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }

    carouselOptions = {
        nav: false,
        rewind: false,
        autoplay: false,
        margin: 30,
        loop: false,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            }
        }
    }



    componentDidMount = () => {

        let queries = queryString.parse(this.props.location.search)
        localStorage.setItem('queries', JSON.stringify(queries))
        let userDataLog = localStorage.getItem("userData");
        userDataLog = { ...queries, userDataLog }
        
        if (queries.AuthorisationCode) {
            localStorage.setItem('paymentStatus', 'success')
        } else {
            localStorage.setItem('paymentStatus', 'fail')
        }
        let eventParams = eventCallRequest('Payment Response Page Loaded', JSON.stringify(userDataLog));
        this.props.eventRequest(eventParams).then(() => {
            if (queries.AuthorisationCode) {
                this.props.history.push("/payment-success");
            } else {
                this.props.history.push("/payment-failure");
            }
         }).catch(() => {
            if (queries.AuthorisationCode) {
                this.props.history.push("/payment-success");
            } else {
                this.props.history.push("/payment-failure");
            }
         });
    }

    render() {
        return (
            <Aux>
                <div className="container-fluid">
                    <div className="row no-gutters">
                        <div className="col-sm-12 col-md-6 col-12">
                            <div className="col my-4 text-center">
                                <Link to="/" className='text-decoration-none'>
                                    <h5 className="fw-bold text-primary"><img alt="" height="20px" style={{ marginRight: '5px' }} src={Logo} />Parking at Grant Park Gateway Deck</h5>
                                </Link>
                            </div>
                            <CarouselItems />
                            <BottomLogo
                                className="my-2 text-center bg-opacity-10 d-none d-sm-block"
                            />
                        </div>
                        <LoadingComponent />
                        <BottomLogo
                            className="my-2 text-center bg-opacity-10 d-block d-sm-none"
                        />
                    </div>
                </div>
            </Aux>
        )
    }
}

const mapStateToProps = ({ PassesReducer, PartnerReducer }) => {
    const { passes, isFetching, paymentRes, getGaragePriceRes, hasError, errorMessage, userPasses } = PassesReducer;
    const { memberCheck, partnerDetails, eventRes } = PartnerReducer;
    return {
        passes,
        userPasses,
        isFetching,
        paymentRes,
        getGaragePriceRes,
        hasError,
        errorMessage,
        memberCheck,
        eventRes,
        partnerDetails
    }
}
const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        eventRequest: (data) => dispatch(actionCreators.logEvent(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(paymentResponse);
